<template>
    <v-container>
        <v-breadcrumbs class="px-0" :items="items"></v-breadcrumbs>
        <v-row class="mt-10">
            <v-col>
                <span class="header bold text-tcdc-green">CONSULT</span>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import ServiceExpandable from "../../components/expandables/ServiceExpandable";
    import { mapState } from 'vuex';

    export default {
        created() {
            this.items[0].text = this.branchName;
        },
        computed: {
            ...mapState({
                branchName: state => state.Branch.branch_name
            }),
            branchChanged: function () {
                return this.branchName;
            }
        },
        watch: {
            branchChanged: function() {
                this.items[0].text = this.branchChanged;
            }
        },
        data: () => ({
            items: [
                {
                    text: 'TCDC BANGKOK',
                    // disabled: true,
                    // href: "breadcrumbs_dashboard",
                    to: "/home"
                },
                {
                    text: "SERVICE",
                    href: "/service",
                    // to: "/service"
                },
                {
                    text: "CONSULT",
                    disabled: true,
                    // href: "breadcrumbs_link_1",
                }
            ]
        }),
        components: {
        }
    };
</script>

<style></style>
